export function transformInfoBoxTags(content: string): {
  transformed: string
  infoBoxes: Map<string, { type: 'tip' | 'note' | 'warning'; content: string }>
} {
  const infoBoxes = new Map<string, { type: 'tip' | 'note' | 'warning'; content: string }>()
  let counter = 0

  const infoBoxRegex = /<(tip|note|warning|important)>([\s\S]*?)<\/(tip|note|warning|important)>/gi
  let transformed = content.replace(infoBoxRegex, (match, openTag, innerContent, closeTag) => {
    if (openTag.toLowerCase() !== closeTag.toLowerCase()) {
      return match
    }

    const tagType = openTag.toLowerCase()
    const type = (tagType === 'important' ? 'warning' : tagType) as 'tip' | 'note' | 'warning'
    const contentId = `infobox-${counter++}`
    infoBoxes.set(contentId, { type, content: innerContent.trim() })

    return `<div class="info-box-wrapper" data-type="${type}" data-content-id="${contentId}"></div>`
  })

  const blockquoteRegex = /(?:^|\n)((?:> ?[^\n]*(?:\n> ?[^\n]*)*))/gm
  transformed = transformed.replace(blockquoteRegex, (match) => {
    const lines = match.trim().split('\n')
    const firstLine = lines[0] || ''

    const typeMatch =
      firstLine.match(/(?:> ?[^\s]*\s+)?\*\*(Tip|Note|Warning|Important)\*\*:?/i) ||
      firstLine.match(/(?:> ?[^\s]*\s+)?(Tip|Note|Warning|Important):?/i)

    let type: 'tip' | 'note' | 'warning'
    let label: string

    if (typeMatch && typeMatch[1]) {
      const matchedLabel: string = typeMatch[1]
      label = matchedLabel.toLowerCase()
      type = (label === 'important' ? 'warning' : label) as 'tip' | 'note' | 'warning'
    } else {
      type = 'note'
      label = ''
    }

    const contentLines = lines
      .map((line, index) => {
        let cleaned = line.replace(/^> ?/, '')
        if (index === 0 && label) {
          cleaned = cleaned.replace(/^[\u2600-\u26FF\u2700-\u27BF]\s*/, '')
          cleaned = cleaned.replace(/^[\uD83D\uD83C][\uDC00-\uDFFF]\s*/, '')
          cleaned = cleaned.replace(/^\s*\*\*(?:Tip|Note|Warning|Important)\*\*:?\s*/i, '')
          cleaned = cleaned.replace(/^\s*(?:Tip|Note|Warning|Important):?\s*/i, '')
          cleaned = cleaned.replace(/\b(?:Tip|Note|Warning|Important):\s*/gi, '')
          cleaned = cleaned.replace(/\*\*/g, '')
        } else if (index === 0 && !label) {
          cleaned = cleaned.replace(/\*\*/g, '')
        } else {
          cleaned = cleaned.replace(/\b(?:Tip|Note|Warning|Important):\s*/gi, '')
          cleaned = cleaned.replace(/\*\*/g, '')
        }
        return cleaned.trim()
      })
      .filter((line) => line.length > 0)
      .join('\n\n')

    if (contentLines.trim().length === 0) {
      return match
    }

    const contentId = `infobox-${counter++}`
    infoBoxes.set(contentId, { type, content: contentLines.trim() })

    return `\n<div class="info-box-wrapper" data-type="${type}" data-content-id="${contentId}"></div>`
  })

  return { transformed, infoBoxes }
}
